import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser, selectGreenhouse } from 'state';
import { DASHBOARD_NOT_AVAILABLE, DATA_NOT_AVAILABLE, ROUTES } from '_constants';
import { GreenhouseList } from 'components/GreenhouseList';
import { Tabs, Tab, TabContainer, TabsLine, StyledPaper } from './Dashboard.styles';
import { Header } from 'components/Header';
import { CanopyDetection } from 'components/CanopyDetection';
import { Redirect } from 'react-router-dom';

const tabNames = ['Canopy Detection Graphs', 'Heat Map'];
export const Dashboard = () => {
  const user = useSelector(selectUser);
  const { selectedGreenhouse, selectedGreenhouseExternalID } =
    useSelector(selectGreenhouse);
  const [selectedTab, setSelectedTab] = useState(tabNames[0]);

  const userToken = user?.token;
  if (!userToken) return <Redirect to={ROUTES.ROOT} />;
  const customerId = user?.customer?.[0]?.external_id;
  const baseUrl =
    process.env.REACT_APP_IFRAME_BASE_URL || 'https://portal.groweradviser.com';

  const renderIframe = () => (
    <iframe
      width='100%'
      height='800px'
      src={`${baseUrl}/streamlit_proxy/?user_token=${userToken}&customer_id=${customerId}&location_id=${selectedGreenhouse}&location_external_id=${selectedGreenhouseExternalID}`}
    ></iframe>
  );

  function renderDashboard(tab) {
    switch (tab) {
      case tabNames[0]:
        return renderIframe();
      case tabNames[1]:
        return <CanopyDetection />;
      default:
        return <StyledPaper>{DATA_NOT_AVAILABLE}</StyledPaper>;
    }
  }

  return (
    <>
      <Header />
      <GreenhouseList />
      {customerId ? (
        <>
          {customerId !== 'oxEe2oxuB0g4at7WgkMO' ? (
            renderIframe()
          ) : (
            <TabContainer padding={1}>
              <Tabs>
                {tabNames.map(v => (
                  <Tab
                    key={v}
                    onClick={() => setSelectedTab(v)}
                    selected={selectedTab === v}
                  >
                    {v}
                  </Tab>
                ))}
                <TabsLine />
              </Tabs>
              {renderDashboard(selectedTab)}
            </TabContainer>
          )}
        </>
      ) : (
        <StyledPaper>{DASHBOARD_NOT_AVAILABLE}</StyledPaper>
      )}
    </>
  );
};
